import { Field } from 'formik'
import times from 'lodash-es/times'
import React from 'react'

import { ButtonClean, Input, InputUI, Select, Subsection } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'
import { useFormikContext } from '@fourthwall/utils/dist/formik'
import { useCurrentShop } from '@modules/Dashboard/hooks/useCurrentShop'

import { MAX_POLL_OPTIONS, MIN_POLL_OPTIONS } from '../../../../consts'
import type { FormValues } from '../../types'
import { FormFields } from '../../types'
import * as S from './PollFields.styled'

type Props = {
  disabled?: boolean
}

export const PollFields = ({ disabled }: Props) => {
  const { currentShop } = useCurrentShop()

  const maxPollDays =
    // VLDL shop
    currentShop && currentShop.id === 'sh_89a6f7e5-dda0-4cea-9336-12291ad88be7' ? 31 : 8

  const { values, errors, setFieldValue } = useFormikContext<FormValues>()
  const pollOptions = values.pollOptions || []

  const handlePollOptionAdd = () => {
    if (pollOptions.length >= MAX_POLL_OPTIONS) {
      return null
    }

    setFieldValue(FormFields.pollOptions, [...pollOptions, ''])
  }

  const handlePollOptionRemove = (optionIndex: number) => {
    const newOptions = [...pollOptions]

    newOptions.splice(optionIndex, 1)
    setFieldValue(FormFields.pollOptions, [...newOptions])
  }

  const renderAdditionalOptions = () => {
    return times(pollOptions.length - MIN_POLL_OPTIONS, (index) => {
      return (
        <Field
          key={index}
          name={`pollOptions.${index + MIN_POLL_OPTIONS}`}
          component={Input}
          placeholder={`Option ${index + MIN_POLL_OPTIONS + 1}`}
          actionIcon={!disabled ? CloseIcon : undefined}
          onActionIconClick={() => handlePollOptionRemove(index + MIN_POLL_OPTIONS)}
          disabled={disabled}
        />
      )
    })
  }

  const renderOptions = () => {
    return times(MIN_POLL_OPTIONS, (index) => {
      return (
        <Field
          key={index}
          name={`pollOptions.${index}`}
          component={Input}
          placeholder={`Option ${index + 1}`}
          disabled={disabled}
        />
      )
    })
  }

  const renderAddButton = () => {
    if (pollOptions.length >= MAX_POLL_OPTIONS || disabled) {
      return null
    }

    return <ButtonClean label="+ Add a poll option" withUnderline onClick={handlePollOptionAdd} />
  }

  return (
    <Subsection title="Poll options">
      <S.Container>
        <S.OptionsContainer>
          {renderOptions()}
          {renderAdditionalOptions()}
          {renderAddButton()}
        </S.OptionsContainer>
        <S.Divider />
        {!disabled && (
          <>
            <p>Poll length</p>
            <S.LengthInputsContainer>
              <Field
                component={Select}
                name="pollLength.days"
                label="Days"
                options={times(maxPollDays, (index) => ({
                  label: `${index}`,
                  value: `${index}`,
                }))}
              />
              <Field
                component={Select}
                name="pollLength.hours"
                label="Hours"
                options={times(24, (index) => ({
                  label: `${index}`,
                  value: `${index}`,
                }))}
              />
              <Field
                component={Select}
                name="pollLength.minutes"
                label="Minutes"
                options={times(60, (index) => ({
                  label: `${index}`,
                  value: `${index}`,
                }))}
              />
            </S.LengthInputsContainer>
            {errors.pollLength && <InputUI.Error>{errors.pollLength}</InputUI.Error>}
          </>
        )}
      </S.Container>
    </Subsection>
  )
}
